var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationCompass2StreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.3443C18.6204 22.3443 22.3443 18.6203 22.3443 12C22.3443 5.37964 18.6204 1.6557 12 1.6557C5.3797 1.6557 1.65576 5.37964 1.65576 12C1.65576 18.6203 5.3797 22.3443 12 22.3443Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4007 8.2103C16.6172 10.342 15.7321 12.5739 14.5193 14.5193L9.48071 9.48052C11.426 8.26778 13.658 7.38258 15.7896 7.59918C16.1134 7.63209 16.3678 7.88651 16.4007 8.2103Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59933 15.7897C7.38286 13.658 8.26795 11.4261 9.48073 9.48071L14.5193 14.5195C12.574 15.7323 10.3421 16.6175 8.2104 16.4009C7.88661 16.368 7.63222 16.1135 7.59933 15.7897Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCompass2StreamlineFlex1);
export default __webpack_public_path__ + "static/media/Location-Compass-2--Streamline-Flex 1.7919bd7f23989242d39c88d9f3ee46cd.svg";
export { ForwardRef as ReactComponent };